import { httpClient, HttpError } from "@coworker/http-client";
import { useQuery } from "@tanstack/react-query";
import { TaskType } from "../enums/taskTypes";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";

export interface TaskByIdAndTypeResponse {
  id: string;
  product_article_id: string;
  state: string;
  finished_at: string;
  [key: string]: unknown;
}

export async function fetchTaskByIdAndType(taskId: string, type: TaskType) {
  return await httpClient.tasks.get<TaskByIdAndTypeResponse>(
    `/v1/task/by-id-type`,
    {
      params: { taskId, type },
    }
  );
}

export function getTaskByIdAndTypeQueryConfig(taskId: string, type: TaskType) {
  return {
    queryKey: ["task", "id", taskId, type],
    queryFn: async () => await fetchTaskByIdAndType(taskId, type),
    staleTime: INTERVAL.MINUTE,
    enabled: !!taskId && !!type,
    retry: (failureCount: number, error: HttpError) =>
      error?.status !== 404 && failureCount < 3,
  };
}

export function useGetTaskByIdAndType(taskId: string, type: TaskType) {
  return useQuery(getTaskByIdAndTypeQueryConfig(taskId, type));
}
